module.exports = __webpack_public_path__ + "static/icon0031583c48504d8f0362f636526f5eb14b5c.png";